<template>
    <div id="hacker-app">
        <v-container>
            <p><pre>  _  _         _
 | || |__ _ __| |_____ _ _
 | __ / _` / _| / / -_) '_|
 |_||_\__,_\__|_\_\___|_|

Welcome. Are you ready to uncover a secret?

<i>Click on a tool below to use it.</i>
</pre></p>

            <div id="hacker-main-menu">
                <div class="hacker-sub-menu" v-for="menu in menus" :key="menu.name">
                    <p><b>{{ menu.name }}<br>{{ '='.repeat(menu.name.length) }}</b></p>
                    <div class="hacker-sub-menu-description" v-if="menu.description">
                        <p v-for="line in menu.description.split('\n')" :key="hashCode(line)"><i>{{ line }}</i></p>
                    </div>
                    <p v-for="action in menu.actions" :key="action.title" class="ma-0">
                        <a @click="setValue(action.prop, action.val)" class="no-link">-> <u>{{ action.title }}</u></a>
                        <span class="hacker-description" v-if="action.description">
                            <i>{{ action.description }}</i>
                        </span>
                    </p>
                </div>
            </div>

            <spoof-dialog v-model="showSpoofDialog"/>
            <malware-dialog v-model="showMalwareDialog"/>
            <osint-dialog v-model="showOsintDialog"/>
            <escape-withdraw-dialog v-model="showEscapeWithdrawDialog" :data="escapeWithdraw"/>
        </v-container>
    </div>
</template>

<script>
import SpoofDialog from '../components/hacker/SpoofDialog.vue';
import MalwareDialog from '../components/hacker/MalwareDialog.vue';
import OsintDialog from '../components/hacker/OsintDialog.vue';
import EscapeWithdrawDialog from '../components/hacker/EscapeWithdrawDialog.vue';

export default {
    name: "Hacker",
    components: {
        SpoofDialog,
        MalwareDialog,
        OsintDialog,
        EscapeWithdrawDialog
    },
    data: () => ({
        showSpoofDialog: false,
        showMalwareDialog: false,
        showOsintDialog: false,
        showEscapeWithdrawDialog: false,
        escapeWithdraw: "",
        menus: [
            {
                name: "Game Control",
                actions: [
                    {
                        title: "Escape!",
                        description: "Escape when you have found all of the information you can about the secret project!",
                        prop: "escapeWithdraw",
                        val: "escape"
                    },
                    {
                        title: "Withdraw",
                        description: "Silently leave the game.",
                        prop: "escapeWithdraw",
                        val: "withdraw"
                    }
                ]
            },
            {
                name: "Online tools",
                actions: [
                    // {
                    //     title: "Attack Computer Network",
                    //     description: "This attack allows you to try and compromise the organizations computer network. As the attack progresses, you may need additional information. This can be noisy and you may get caught."
                    // },
                    {
                        title: "Malware",
                        description: "This includes a keylogger for intercepting messages between players and allows you to manage malware that you have created and see information that has been collected.",
                        prop: "showMalwareDialog",
                        val: true
                    },
                    {
                        title: "Spoof",
                        description: "This enables you to pretend to be someone else on email, message or social media.",
                        prop: "showSpoofDialog",
                        val: true
                    }
                ]
            },
            {
                name: "Publicly available information",
                description: "Open Source Intelligence (OSINT) is the process of discovering information about a target based on what can be found freely online.\nThis takes some time but can produce useful information to use during your attack.\nIf you turn this tool on, you will automatically get a feed of information about your target every day. You'll have to decide what is useful and how you will use it.",
                actions: [
                    // {
                    //     title: "Turn On"
                    // },
                    {
                        title: "Show OSINT Information",
                        prop: "showOsintDialog",
                        val: true
                    }
                ]
            },
            // {
            //     name: "Physical Site",
            //     actions: [
            //         {
            //             title: "Observe the site",
            //             description: "You will be able to see and hear the conversations of the group so long as it takes place outside a meeting room. They will not know you are there but you will not be able to interact with anyone."
            //         },
            //         {
            //             title: "Visit the site",
            //             description: "You will appear on the camera in the same way as the rest of the group and will be able to interact with them using any cover you think will work."
            //         }
            //     ]
            // }
        ]
    }),
    methods: {
        hashCode(str) {
            var h = 0, l = str.length, i = 0;
            if (l > 0) {
                while (i < l) {
                    h = (h << 5) - h + str.charCodeAt(i++) | 0;
                }
            }

            return h;
        },
        setValue(prop, val) {
            this[prop] = val;
        }
    },
    watch: {
        escapeWithdraw(val) {
            if (val == "escape" || val == "withdraw") {
                this.showEscapeWithdrawDialog = true;
            }
        }
    }
}
</script>

<style scoped>
    * {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
    }
</style>

<style scoped>
    #hacker-app {
        background: #262626;
        color: #4af626;
        height: 100%;
        /* font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important; */
    }

    .hacker-sub-menu {
        padding-top: 20px;
    }

    #hacker-console {
        overflow-x: auto;
    }

    .hacker-description {
        display: block;
        padding-left: 50px;
    }

    .no-link {
        color: inherit;
        text-decoration: none;
    }
</style>
